export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };
  };

export const translateText = (textToTranslate, category, language, text) => {
    if (!textToTranslate) return textToTranslate;

    // ترجمة العناوين
    if (category === 'title') {
      // محاولة المطابقة الدقيقة أولاً
      if (text[language].reportTitles && text[language].reportTitles[textToTranslate]) {
        return text[language].reportTitles[textToTranslate];
      }

      // إذا لم تنجح المطابقة الدقيقة، حاول مطابقة نوع التقرير
      if (language === 'ar') {
        const titleLower = textToTranslate.toLowerCase();
        
        if (titleLower.includes('performance')) {
          return 'أداء الموظفين Q' + (textToTranslate.match(/Q\d/) ? textToTranslate.match(/Q\d/)[0].replace('Q', '') : '') + ' ' + new Date().getFullYear();
        }
        if (titleLower.includes('payroll')) {
          const monthMatch = textToTranslate.match(/January|February|March|April|May|June|July|August|September|October|November|December/i);
          const monthName = monthMatch ? monthMatch[0] : '';
          const monthArabic = {
            'January': 'يناير', 'February': 'فبراير', 'March': 'مارس', 'April': 'أبريل',
            'May': 'مايو', 'June': 'يونيو', 'July': 'يوليو', 'August': 'أغسطس',
            'September': 'سبتمبر', 'October': 'أكتوبر', 'November': 'نوفمبر', 'December': 'ديسمبر'
          };
          return 'ملخص الرواتب الشهري - ' + (monthArabic[monthName] || monthName) + ' ' + new Date().getFullYear();
        }
        if (titleLower.includes('attendance')) {
          return 'تحليلات الحضور الأسبوعية';
        }
        if (titleLower.includes('recruitment') || titleLower.includes('hiring')) {
          return 'تحليل التوظيف والتعيين - ' + new Date().getFullYear();
        }
        if (titleLower.includes('training') || titleLower.includes('development')) {
          return 'تقرير تقدم التدريب والتطوير';
        }
        if (titleLower.includes('budget')) {
          return 'تحليل الميزانية - ' + new Date().getFullYear();
        }
      }
      
      return textToTranslate;
    }

    // ترجمة الوصف
    // if (category === 'description' && text[language].reportDescriptions && text[language].reportDescriptions[textToTranslate]) {
    //   return text[language].reportDescriptions[textToTranslate];
    // }

    // ترجمة المؤلفين
    if (category === 'author' && text[language].authors && text[language].authors[textToTranslate]) {
      return text[language].authors[textToTranslate];
    }

    // ترجمة التاغات
    // if (category === 'tag' && text[language].tags && text[language].tags[textToTranslate]) {
    //   return text[language].tags[textToTranslate];
    // }

    return textToTranslate;
  };
  